import React from 'react';
import cls from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart } from '@fortawesome/pro-solid-svg-icons';

import { TetheredModal } from 'src/explore/elements/TetheredModal';

import styles from './index.module.sass';

interface LoveScoreProps {
  className?: {
    modal?: string;
    tether?: string;
  };
  score: number;
}

export const LoveScore = ({ className, score }: LoveScoreProps ) => (
  <TetheredModal
    className={cls( 'spec__love-score', className?.tether )}
    tether={
      <span className={`${styles.tether}`}>
        <FontAwesomeIcon className="mr-1 text-dark" icon={faHeart} />
        <span>{score}% love this shop</span>
      </span>
    }
  >
    <div className={cls( styles.modal, 'font-weight-normal ff-cabin', className?.modal )}>
      <strong className="d-block fs-6">{score}% of customers love this!</strong>

      <p className="mt-1">
        The Customer Love Score represents the percentage of customers that have loved their orders
        and the foods from this shop.
      </p>
    </div>
  </TetheredModal>
);
